import { render, staticRenderFns } from "./form9.vue?vue&type=template&id=6a1918bc&scoped=true"
import script from "./form9.vue?vue&type=script&lang=js"
export * from "./form9.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1918bc",
  null
  
)

export default component.exports